import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import {
    loginLoading,
    loginReject,
    loginRequest,
    loginSuccess,
} from "../../actions/login";

export const login = (formData) => async (dispatch) => {

    dispatch(loginLoading());

    try {

        const { data } = await loginRequest(formData);

        if (!isEmpty(get(data, "data"))) {

            const userData = get(data, "data");

            // guardar token
            localStorage.setItem("token", userData.tokenGenerated);

            // guardar usuario
            localStorage.setItem("userData", JSON.stringify(userData));

            dispatch(loginSuccess({
                isLogged: true,
                dataUser: userData
            }));

        } else {
            dispatch(loginReject({ Message: "Credenciales incorrectas. Verifique su usuario y contraseña." }));
        }

    } catch (error) {
        dispatch(loginReject(get(error, "response.data")));
    }

    return Promise.resolve();
};